import type * as React from 'react';

import { getSourceEventParams, useAmplitude } from '@crehana/analytics';
import ArrowRight from '@crehana/icons/outline/ArrowRight';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Col, Container, InverseButton, Row } from '@crehana/ui';

import type { CampaignProps } from '@/views/Campaign/types';

import { LeftContent, Wrapper } from './Courses.styles';
import CategorySlider from './components/CategorySlider';

const Courses: React.FC<React.PropsWithChildren<CampaignProps['courses']>> = ({
  backgroundDesktop,
  backgroundMobile,
  callToAction,
  callToActionUrl,
  title,
  description,
  titleCategory,
}) => {
  const { logEvent } = useAmplitude();

  const handleCtaClick = () => {
    logEvent({
      event: 'Click Courses CTA',
      data: {
        ...getSourceEventParams(),
        'CTA Url': callToActionUrl,
        'CTA Label': callToAction,
      },
    });
    return true;
  };

  return (
    <Wrapper
      id="courses-section"
      className="lg:flex items-center justify-center relative pb-32 lg:py-0"
      bgDesktop={backgroundDesktop}
      bgMobile={backgroundMobile}
    >
      <Container className="relative z-2">
        <Row>
          <Col xs={12} lg={5} className="lg:flex">
            <LeftContent className="text-center mx-auto my-auto lg:mx-0 lg:text-left">
              <h2 className="font-h1 lg:mt-0 text-white">{title}</h2>
              <p className="font-body2 my-32 text-white">{description}</p>
              <InverseButton
                leftIcon={{ component: ArrowRight, size: 20 }}
                isWhite
                as="a"
                size="l"
                href={callToActionUrl}
                label={callToAction}
                onClick={handleCtaClick}
              />
            </LeftContent>
          </Col>
          <Col xs={12} lg={7} className="hidden sm:block">
            <CategorySlider titleCategory={titleCategory} />
          </Col>
        </Row>
      </Container>
      <div className="sm:hidden relative mt-24">
        <CategorySlider titleCategory={titleCategory} />
      </div>
    </Wrapper>
  );
};

export default Courses;
